import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import MainLayout from "../../components/Common/MainLayout/MainLayout";
import { createPoll } from "../../utils/mainTabs/social/createPoll";
import { formuArea } from "../../utils/mainTabs/social/forumArea";
import { lockedByOthers } from "../../utils/mainTabs/social/lockedByOthers";
import { moderateContributions } from "../../utils/mainTabs/social/moderateContributions";
import { myModerations } from "../../utils/mainTabs/social/myModerations";
import { pollManagement } from "../../utils/mainTabs/social/pollManagement";
import { pollResult } from "../../utils/mainTabs/social/pollResult";
import { published } from "../../utils/mainTabs/social/published";
import { publishedByOthers } from "../../utils/mainTabs/social/publishedByOthers";
import { rejected } from "../../utils/mainTabs/social/rejected";
import { social } from "../../utils/mainTabs/social/social";
import { submisssions } from "../../utils/mainTabs/social/submissions";
import { tileSize } from "../../utils/tileSizes";
import { tileTypes } from "../../utils/tileTypes";
import {
  isShortclassNameExistsActionHandler,
  updateShotClassSourcingActionHandler,
} from "../../store/actions/actionHandlers/socialActionHandler";
import { setErrorHandler } from "../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../utils/errorTypes";
import {
  setShotClassFormData,
  setViewComments,
} from "../../store/actions/actionCreators/socialActionCreator";
import loaders from "../../store/actions/actionCreators/loadersActionCreator";

const SocialPage = () => {
  const { tenantName } = useOutletContext();
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [socialHeader, setsocialHeader] = useState("");
  const [socialTiles, setsocialTiles] = useState([]);
  const [socialNavLinks, setsocialNavLinks] = useState([]);
  const [socialTileType, setsocialTileType] = useState(tileTypes.SMALL);
  const [socialTileSize, setsocialTileSize] = useState(tileSize.SMALL);
  const location = useLocation();
  const [socialButtons, setSocialButtons] = useState([]);
  const [isSocialStepTile, setisSocialStepTile] = useState(false);
  const [rightSideLinks, setRightSideLinks] = useState([]);
  const [viewCommentModal, setViewCommentModal] = useState(false);
  const socialState = useSelector((state) => state.socialReducer);
  const { shotClassFormData } = socialState;
  const commonState = useSelector((state) => state.commonReducer);
  const { userRoleMenu } = commonState;
  const { pollId } = useParams();
  const [saveShotclassLoader, setSaveShotclassLoader] = useState(false);

  const setSocialTilesOnUserRoleMenu = useCallback(
    (data) => {
      let isPollRender = false,
        isForumAreaRender = false,
        isModerateContributionRender = false;
      userRoleMenu?.forEach((role) => {
        if (role?.Title === "POLL") isPollRender = true;
        if (role?.Title === "FORUM_TEXT") isForumAreaRender = true;
        if (role?.Title === "Moderate_Shotclasses")
          isModerateContributionRender = true;
      });
      const socialTiles = data?.map((tile) => {
        if (
          (tile.path === pollManagement.path(tenantName) && isPollRender) ||
          (tile.path === formuArea.path(tenantName) && isForumAreaRender) ||
          (tile.path === moderateContributions.path(tenantName) &&
            isModerateContributionRender)
        )
          return {
            ...tile,
            isVisible: true,
          };
        else
          return {
            ...tile,
            isVisible: false,
          };
      });
      setsocialTiles(socialTiles);
    },
    [tenantName, userRoleMenu]
  );

  const saveShotclass = useCallback(() => {
    if (shotClassFormData) {
      setSaveShotclassLoader(true);
      dispatch(
        isShortclassNameExistsActionHandler(
          shotClassFormData?.details?.shotclassName
        )
      ).then((res) => {
        if (res.status === 200) {
          // debugger
          if (res.data) {
            setSaveShotclassLoader(false);
            dispatch(
              setErrorHandler(errorTypes.FAIL, `Class Name is already exist.`)
            );
          } else {
            dispatch(
              updateShotClassSourcingActionHandler(
                shotClassFormData,
                navigate,
                tenantName
              )
            ).then((res) => {
              if (res?.data) {
                dispatch(
                  setErrorHandler(
                    errorTypes.SUCCESS,
                    `Your Shotclass ${shotClassFormData?.details?.ShotClassName} is published. You can view same in Distribute Shotclass and/or My Published Classes`
                  )
                );
                dispatch(
                  loaders.manage.createShotclasses.shotclassPublishLoader(false)
                );
                navigate(submisssions.path(tenantName));
                dispatch(setViewComments(false));
                dispatch(setShotClassFormData(null));
              }
              setSaveShotclassLoader(false);
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  `${shotClassFormData?.details?.ShotClassName} Content saved successfully`
                )
              );
            });
            navigate(submisssions.path(tenantName));
          }
        }
      });
    }
  }, [dispatch, navigate, params, shotClassFormData, tenantName]);

  useEffect(() => {
    const { name, tiles } = social;
    if (location.pathname === social.path(tenantName)) {
      // setSocialTilesOnUserRoleMenu(tiles(navigate, tenantName));
      setsocialHeader(name);
      setsocialNavLinks([]);
      setsocialTileType(tileTypes.SMALL);
      setsocialTileSize(tileSize.SMALL);
      setisSocialStepTile(false);
      setRightSideLinks([]);
      setSocialButtons([]);
      setsocialTiles(tiles(navigate, tenantName));
    } else if (location.pathname === pollManagement.path(tenantName)) {
      const { navLinks } = pollManagement;
      setsocialHeader("");
      setsocialTiles([]);
      setsocialNavLinks(navLinks(navigate, tenantName));
      setRightSideLinks([]);
    } else if (location.pathname === createPoll.path(tenantName)) {
      const { navLinks } = createPoll;
      setsocialHeader("");
      setsocialTiles([]);
      setsocialNavLinks(navLinks(navigate, tenantName));
      setRightSideLinks([]);
    } else if (
      location.pathname ===
      `${pollResult.path(tenantName)}/pollResult/${pollId}`
    ) {
      const { navLinks } = pollResult;
      setsocialHeader("");
      setsocialTiles([]);
      setsocialNavLinks(navLinks(navigate, tenantName));
      setRightSideLinks([]);
    } else if (location.pathname === formuArea.path(tenantName)) {
      const { navLinks } = formuArea;
      setsocialHeader("");
      setsocialTiles([]);
      setsocialNavLinks(navLinks(navigate, tenantName));
      setRightSideLinks([]);
    } else if (
      location.pathname === submisssions.path(tenantName) ||
      location.pathname === myModerations.path(tenantName) ||
      location.pathname === lockedByOthers.path(tenantName) ||
      location.pathname === rejected.path(tenantName) ||
      location.pathname === published.path(tenantName) ||
      location.pathname === publishedByOthers.path(tenantName)
    ) {
      const { navLinks, tiles } = moderateContributions;
      setsocialHeader("");
      setsocialTiles(tiles(navigate, tenantName));
      setsocialTileSize(tileSize.EXTRA_SMALL);
      setsocialTileType(tileTypes.DEFAULT);
      setsocialNavLinks(navLinks(navigate, tenantName));
      setisSocialStepTile(false);
      setRightSideLinks([]);
      setSocialButtons([]);
    } else if (
      location.pathname.includes(
        submisssions.shotClassespath(params, location, tenantName)
      )
    ) {
      const { navLinks, tiles, buttons } = submisssions;
      setsocialTileType(tileTypes.DEFAULT);
      setisSocialStepTile(true);
      setsocialNavLinks(
        navLinks(
          navigate,
          location.pathname.includes(
            `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`
          )
            ? "View Shotclasses"
            : "Update Shotclasses",
          tenantName
        )
      );
      setsocialHeader("");
      setSocialButtons(
        buttons(
          viewCommentModal,
          setViewCommentModal,
          location,
          dispatch,
          params,
          navigate,
          shotClassFormData,
          tenantName,
          saveShotclass,
          saveShotclassLoader
        )
      );
      // if (
      //   location.pathname.includes(
      //     `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`
      //   ) ||
      //   location.pathname.includes(
      //     `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`
      //   )
      // )
      //   setsocialTiles(
      //     tiles(
      //       navigate,
      //       location,
      //       params,
      //       location.pathname.includes(
      //         `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`
      //       )
      //         ? "viewShotclasses"
      //         : "updateShotclasses",
      //       tenantName
      //     )
      //   );
    }
  }, [
    location,
    navigate,
    params,
    viewCommentModal,
    dispatch,
    shotClassFormData,
    tenantName,
    pollId,
    userRoleMenu,
    setSocialTilesOnUserRoleMenu,
    saveShotclass,
    saveShotclassLoader,
  ]);

  return (
    <MainLayout
      heading={socialHeader}
      tiles={socialTiles}
      buttons={socialButtons}
      navLinks={socialNavLinks}
      tileType={socialTileType}
      tileSize={socialTileSize}
      isStepTile={isSocialStepTile}
      rightSideLinks={rightSideLinks}
    >
      <Outlet
        context={{
          manageTiles: socialTiles,
          setManageTiles: setsocialTiles,
          setManageButtons: setSocialButtons,
          viewCommentModal,
          setViewCommentModal,
          tenantName,
        }}
      />
    </MainLayout>
  );
};

export default SocialPage;
